export default __webpack_public_path__ + "872ebb8.png";